module.exports = __webpack_public_path__ + "img/desktop.896bc4cf.png";